import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=5c23391a&scoped=true&"
import script from "./HistoryModal.vue?vue&type=script&lang=js&"
export * from "./HistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HistoryModal.vue?vue&type=style&index=1&id=5c23391a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23391a",
  null
  
)

export default component.exports